{
	"importSuccessNotification": "Plan of accounts imported successfully.",
	"onChangeSuccessNotification": "File {{name}} successfully uploaded",
	"errorNotification": "File {{name}} upload failed",
	"deleteSuccessNotification": "Plan of accounts deleted.",
	"showTree": "View Plan of accounts tree",
	"export": "Export Spreadsheet",
	"delete": "Delete Plan of Accounts",
	"enter": "enter",
	"esc": "esc",
	"showTreeTitle": "Plan of Accounts tree",
	"deleteConfirmDialog": "Are you sure you want to delete the Plan of accounts?",
	"downloadTemplate": "Download Template Spreadsheet",
	"chooseName": "Choose a name!",
	"existingName": "Name already existing",
	"createNewAccount": "Create new account",
	"createSuggestedPlan": "Use suggested Plan of accounts",
	"deleteBillPlanSuccessNotification": "Account {{name}} successfully deleted",
	"deleteBillPlanConfirmDialog": "Are you sure you want to delete the account \"{{name}}\"?",
	"hasBillsMessage": "This account already has transactions associated with it.",
	"editPlanOfAccountsSuccess": "Plan of accounts successfully edited.",
	"name": "Name",
	"parent": "Category parent",
	"parentPlaceholder": "Select a new parent..."
}
